export enum Color {
  UNSET = 'unset',
  RED = 'red',
  GREEN = 'green',
  BLUE = 'blue',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  PURPLE = 'purple',
  PINK = 'pink',
  BROWN = 'brown',
  CYAN = 'cyan',
  LIME = 'lime',
}
